/**
 * Deterministic JSON.stringify with sorted keys (recursive). Two objects with
 * the same content but different key insertion order produce the same string
 * — important for cache keys so we don't miss hits when the LLM happens to
 * emit params in a different order than the frontend.
 */
export function stableStringify(value: any): string {
	if (value === null || typeof value !== 'object') {
		return JSON.stringify(value);
	}
	if (Array.isArray(value)) {
		return '[' + value.map(stableStringify).join(',') + ']';
	}
	const keys = Object.keys(value).sort();
	return '{' + keys.map(k => JSON.stringify(k) + ':' + stableStringify(value[k])).join(',') + '}';
}

/**
 * Build the cache key for a direct external tool execution. Mirrors the key
 * built in handlers/data-request.ts so that pre-populating from the dash-comp
 * picker hits the same slot the frontend looks up at render time.
 */
export function buildDirectToolCacheKey(toolId: string, parameters: Record<string, any> | undefined): string {
	return `et-direct:${toolId}:${stableStringify(parameters || {})}`;
}
